import { useEffect, useState } from "react";
import { MdAdd, MdEdit, MdArticle } from "react-icons/md";
import Card from "components/card";
import { api } from "api";

const TYPE_LABELS: Record<string, string> = { text: "Metin", html: "HTML", link: "Link", json: "JSON" };

const Content = () => {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState<number | null>(null);
  const [form, setForm] = useState({ key: "", title: "", content: "", content_type: "text" });
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const load = () => {
    setLoading(true);
    api.getContent().then(setItems).catch(console.error).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []); // eslint-disable-line

  const openCreate = () => {
    setEditId(null);
    setForm({ key: "", title: "", content: "", content_type: "text" });
    setError("");
    setShowForm(true);
  };

  const openEdit = (item: any) => {
    setEditId(item.id);
    setForm({ key: item.key, title: item.title, content: item.content, content_type: item.content_type });
    setError("");
    setShowForm(true);
  };

  const handleSave = async () => {
    setError("");
    if (!form.key || !form.title || !form.content) { setError("Tum alanlar zorunludur"); return; }
    try {
      if (editId) {
        await api.updateContent(editId, { title: form.title, content: form.content, content_type: form.content_type });
        setMsg("Icerik guncellendi!");
      } else {
        await api.createContent(form);
        setMsg("Icerik eklendi!");
      }
      setShowForm(false);
      load();
      setTimeout(() => setMsg(""), 3000);
    } catch (e: any) { setError(e.message); }
  };

  return (
    <div>
      {msg && <div className="mb-4 rounded-xl bg-green-50 p-3 text-sm text-green-700">{msg}</div>}

      <div className="mt-3 flex items-center justify-between">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">Icerik Yonetimi ({items.length})</h4>
        <button onClick={openCreate} className="flex items-center gap-2 rounded-xl bg-brand-500 px-5 py-2.5 text-sm font-medium text-white hover:bg-brand-600 transition">
          <MdAdd className="h-5 w-5" /> Yeni Icerik
        </button>
      </div>

      <Card extra="mt-4 p-4">
        {loading ? (
          <p className="p-4 text-center text-gray-500">Yukleniyor...</p>
        ) : items.length === 0 ? (
          <div className="p-8 text-center">
            <MdArticle className="mx-auto h-12 w-12 text-gray-300 mb-3" />
            <p className="text-gray-500 mb-1">Henuz icerik yok</p>
            <p className="text-sm text-gray-400">Uygulama ici metinleri buradan yonetebilirsiniz</p>
            <p className="text-xs text-gray-400 mt-2">Ornek key'ler: hakkinda, kvkk, iletisim, kullanim_kosullari</p>
          </div>
        ) : (
          <div className="space-y-3">
            {items.map((item) => (
              <div key={item.id} className="flex items-start justify-between rounded-xl border border-gray-100 p-4 hover:bg-gray-50 dark:border-navy-700 dark:hover:bg-navy-700/50 transition">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-mono text-xs text-brand-500 bg-brand-50 px-2 py-0.5 rounded dark:bg-brand-900/20">{item.key}</span>
                    <span className="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">{TYPE_LABELS[item.content_type] || item.content_type}</span>
                    {!item.is_active && <span className="rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-600">Pasif</span>}
                  </div>
                  <h5 className="font-bold text-navy-700 dark:text-white">{item.title}</h5>
                  <p className="text-sm text-gray-600 mt-1 line-clamp-2">{item.content}</p>
                </div>
                <button onClick={() => openEdit(item)} className="ml-4 text-brand-500 hover:text-brand-700"><MdEdit className="h-5 w-5" /></button>
              </div>
            ))}
          </div>
        )}
      </Card>

      {/* Form Modal */}
      {showForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={() => setShowForm(false)}>
          <div className="w-full max-w-lg rounded-2xl bg-white p-6 dark:bg-navy-800" onClick={(e) => e.stopPropagation()}>
            <h3 className="text-xl font-bold text-navy-700 dark:text-white mb-4">{editId ? "Icerik Duzenle" : "Yeni Icerik"}</h3>
            {error && <div className="mb-4 rounded-xl bg-red-50 p-3 text-sm text-red-600">{error}</div>}
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Key * (benzersiz, degistirilemez)</label>
                <input type="text" value={form.key} onChange={(e) => setForm({ ...form, key: e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, "_") })}
                  disabled={!!editId} placeholder="Orn: hakkinda, kvkk, iletisim"
                  className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm font-mono outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white disabled:opacity-50" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Baslik *</label>
                <input type="text" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })}
                  placeholder="Icerik basligi" className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Icerik Tipi</label>
                <select value={form.content_type} onChange={(e) => setForm({ ...form, content_type: e.target.value })}
                  className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white">
                  <option value="text">Metin</option>
                  <option value="html">HTML</option>
                  <option value="link">Link</option>
                  <option value="json">JSON</option>
                </select>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Icerik *</label>
                <textarea value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })}
                  placeholder="Icerik metni" rows={6} className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white" />
              </div>
            </div>
            <div className="mt-6 flex gap-3 justify-end">
              <button onClick={() => setShowForm(false)} className="rounded-xl px-5 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-100">Iptal</button>
              <button onClick={handleSave} className="rounded-xl bg-brand-500 px-5 py-2.5 text-sm font-medium text-white hover:bg-brand-600">{editId ? "Guncelle" : "Ekle"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Content;
